import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import AlbumModal from './album-modal';

@inject('albumsStore')
@observer
class NewAlbumButton extends React.Component {
	render () {
		return (
			<div>
				<AlbumModal
					contentLabel="New Album"
					button={({ onClick }) => (
						<button className="add-button button" onClick={ onClick }>
							<span className="icon fi-plus"></span> Add Album
						</button>
					)}
				/>
			</div>
		);
	}
}

export default NewAlbumButton;
